import {Step} from 'react-joyride';
import {tourText} from '../../texts/coursesText';
import {stepConfig} from './coursesStepConfig';
import {buildSteps} from '../../utils/buildSteps';

export const getCoursesSteps = (): Step[] =>
  buildSteps(stepConfig, tourText, 'Courses');
